export { renderTab_unstable as renderTab } from '@fluentui/react-tabs';
